import { IQuyDinhSoTinChi } from "../../model/respone/lop-tin-chi/IQuyDinhSoTinChi";
import { IQuyDinhSoTinChiViewModel } from "../../model/respone/lop-tin-chi/IQuyDinhSoTinChiViewModel";
import { apiClient } from "../apiClient";

const QUY_DINH_SO_TIN_CHI_API = "quy-dinh-so-tin-chi";
export const quyDinhSoTinChiApi = {
    SelectAll: () => apiClient.get(`${QUY_DINH_SO_TIN_CHI_API}`),
    SelectByHocKyNamHoc: (hocKy: number, namHoc: string) => apiClient.get(`${QUY_DINH_SO_TIN_CHI_API}/hoc-ky/${hocKy}/nam-hoc/${namHoc}`),
    Insert: (payload: IQuyDinhSoTinChi) => apiClient.post(`${QUY_DINH_SO_TIN_CHI_API}`, payload),
    Update: (payload: IQuyDinhSoTinChi) => apiClient.put(`${QUY_DINH_SO_TIN_CHI_API}`, payload),
    Delete: (id: number) => apiClient.delete(`${QUY_DINH_SO_TIN_CHI_API}/${id}`),
    Submit: (payload: IQuyDinhSoTinChiViewModel) => apiClient.put(`${QUY_DINH_SO_TIN_CHI_API}/submit`, payload),
}